import React from 'react';
import PropTypes from 'prop-types';
import { Text, Button, Icon } from '../../Atoms';
import { Modal } from '../../Molecules';
import { COLOR_BUTTON, MOBILE_APP_LINKS } from '../../Config/Config';

ModalDownloadApp.propTypes = {
  show: PropTypes.bool,
  isIOS: PropTypes.bool,
  onClose: PropTypes.func,
  onDownloadClick: PropTypes.func
};

ModalDownloadApp.defaultProps = {
  show: false,
  isIOS: false,
  onClose: () => {},
  onDownloadClick: () => {}
};

function ModalDownloadApp(props) {
  const storeUrl = props.isIOS ? MOBILE_APP_LINKS.ios : MOBILE_APP_LINKS.android;

  const handleDownloadClick = () => {
    props.onDownloadClick();
    if (storeUrl) {
      window.open(storeUrl, '_blank', 'noopener,noreferrer');
    }
    props.onClose();
  };

  return (
    <Modal
      show={props.show}
      showIconClose={false}
      centered={true}
      onHide={props.onClose}
      contentClassName="content-modal-download-app"
      dialogClassName="dialog-modal-download-app"
    >
      <dialog
        open
        className="full-container dialog-download-app"
        aria-label="Profitez d'une meilleure expérience sur mobile"
      >
        <button
          type="button"
          className="icon-close-modal-download-app"
          onClick={props.onClose}
          aria-label="Fermer la fenêtre"
        >
          <Icon icon="BigX" size="20px" />
        </button>
        <Text
          text="Profitez d'une meilleure expérience sur mobile"
          className="title-modal-download-app"
        />
        <Text
          text="Notre application mobile vous offre une navigation plus rapide et une expérience optimisée pour votre smartphone."
          className="text-description-download-app"
        />
        <div className="container-center container-btn-download-app">
          {!!storeUrl && (
            <Button
              type="primary"
              text="Télécharger l'application"
              onClick={handleDownloadClick}
              color={COLOR_BUTTON.GREEN}
            />
          )}
          <Button
            type="primary"
            text="Continuer sur le Web"
            onClick={props.onClose}
            color={COLOR_BUTTON.GREEN}
            isAlreadyOutline={true}
          />
        </div>
      </dialog>
    </Modal>
  );
}

export default ModalDownloadApp;
